<template>
  <div class="shadow-sm rounded-lg p-4">
    <h4 class="font-bold text-xl leading-7 mb-4 block">Accounts Details</h4>

    <div class="grid grid-cols-2 gap-2">
      <div>
        <div class="flex-col">
          <label class="block text-sm font-semibold text-gray-900 gd-dt ">
            Account ID
          </label>
          <p class="mb-2 text-gray-500">
            {{ user ? user.id : '' }}
          </p>
        </div>
        <div>
          <label class="block text-sm font-semibold text-gray-900 gd-dt">
            Account Email
          </label>
          <p class="text-gray-500">
            {{ this.$route.params.id }}
          </p>
        </div>
        <div class="flex justify-between items-center w-1/2">
          <div>
            <label class="block text-sm font-semibold text-gray-900 gd-dt">
              First Name
            </label>
            <p class="text-gray-500">
              {{ user?.first_name || ' - ' }}
            </p>
          </div>
          <div>
            <label class="block text-sm font-semibold text-gray-900 gd-dt">
              Last Name
            </label>
            <p class="text-gray-500">
              {{ user?.last_name || ' - ' }}
            </p>
          </div>
        </div>
      </div>

      <div>
        <div>
          <label class="block text-sm font-semibold text-gray-900 gd-dt">
            Status
          </label>
          <span v-if="user.is_active" class="bg-green-100 mb-2 text-green-800 px-2 py-1 rounded-lg">
            Active
          </span>

          <span v-else class="bg-gray-100 text-gray-800 px-2 mb-2 py-1.5">
            In Active
          </span>
        </div>
        <div>
          <label class="block text-sm font-semibold text-gray-900 gd-dt mt-2">
            Joined date
          </label>
          <p class="text-gray-500">
            {{ formatDateBasic(user?.created) || ' - ' }}
          </p>
        </div>
        <div>
          <label class="block text-sm font-semibold text-gray-900 gd-dt">
            Last Log in
          </label>
          <p class="text-gray-500">
            {{ formatDate(user.last_login) || '-' }}
          </p>
        </div>
        <div class="mt-2">
          <label class="block text-sm font-semibold text-gray-900 gd-dt">
            Banned
          </label>
          <label class="switch">
            <input type="checkbox" v-model="UserBanned.is_active" :class="{ isBannedToggle: UserBanned.is_active }"
              @change="actionBoolean(UserBanned.is_active)">
            <span class="slider-banned"></span>
          </label>
          <t-modal ref="bannedModal" 
         @before-close="onBeforeClose"
          >
            
            <div class="text-sm flex-col text-center items-center">
              <label class="text-center font-semibold text-lg leading-relaxed">
                {{ `${UserBanned.is_active === true ? 'Are you sure you want to ban this account?' 
                : 'Are you sure you want to unban this account?'}
                `}}
              </label>
              <p class="text-center text-gray-500 text-base leading-relaxed">
                {{ `${UserBanned.is_active === true ? "Once you save this data and ban this account, then the user will not be able to use this account." : 
                'Once you save this data and unban this account, then the user will be able to use this account again.'}` }}
              </p>
            </div>
            <div class="flex justify-center">
                <button class="bg-blue-700 text-white border p-1 px-2 rounded-lg text-sm"
                @click="handleBannded()">
                Save
              </button>
              <button class="text-gray-500 border p-1 px-2 rounded-lg mr-1 ml-2 text-sm" @click="cancel">
                Cancel
              </button>
            </div>
          </t-modal>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import moment from "moment";
import { mapActions, mapMutations } from "vuex";
import API from "../../plugins/http"
import { EventBus } from '../../event-bus'
export default {
  name: "Profile",
  data() {
    return {
      isBanned: null,
      UserBanned: {}
    }
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    userBannedDetailUserId: {
      type: Object,
      default: () => ({}),
      deep: true
    },
  },
  mounted() {
    this.fetchBannedData();
  },
  watch: {
    userBannedDetailUserId: {
      handler(newVal) {
        this.UserBanned = { ...newVal };
      },
      immediate: true,
      deep: true,
    }
  },

  methods: {
    ...mapActions("users", ["fetchBanned"]),
    ...mapMutations("users", ["setItems", "setRows"]),
    async fetchBannedData() {
      try {
        let data = {
          email: this.$route.params.id,
        };
        await this.fetchBanned(data);
      } catch (error) {
        console.log(error);
      }
    },
    formatDate(date) {
      return moment(date).format("DD MMMM YYYY, HH:mm:ss");
    },
    formatDateBasic(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    actionBoolean(isBanned) {
      this.isBanned = isBanned
      this.$refs.bannedModal.show();
    },
    cancel() {
      this.$refs.bannedModal.hide();
    },
    onBeforeClose() {
      this.UserBanned.is_active = !this.UserBanned.is_active;
    },
    handleBannded() {
      let payload = {
        user_id: this.user.id,
        is_banned: this.isBanned 
      };

      API.post(`/user-banned/banned-unbanned/`, payload)
        .then((response) => {
          if(response.status === 201) {
            EventBus.$emit('show-toast', {
            message: `${ this.isBanned === true ? "Banned" : 'Unbanned'} Success`,
            type: 'success',
          });
            this.fetchBannedData()
          }
       
        }).catch((error) => {
          let response = error.response
          if (response.status == 403) {
            EventBus.$emit('show-toast', {
              message: `You Do not have access to  Users`,
              type: 'error',
            });
          }
        })
        this.$refs.bannedModal.hide();
    },
  },
}
</script>
<style>
.switch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 20px;
}

.switch input {
  display: none;
}

.slider-banned {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #9CA3AF;
  border-radius: 40px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider-banned:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  background: #fff;
  border-radius: 50%;
  left: 0px;
  bottom:1px;
  transition: 0.4s;
  border: 1px solid #ccc
}

input[type="checkbox"].isBannedToggle:checked+.slider-banned {
  background: #0060AF !important;
}

input[type="checkbox"].isBannedToggle:checked+.slider-banned:before {
  -webkit-transform: translateX(30px);
  -moz-transform: translateX(30px);
  transform: translateX(30px);
  left: -8px;
}
</style>
